import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface PlanningPlanIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function PlanningPlanIcon({
  color = RoutalPalette.secondary20,
  style = {},
  ...props
}: PlanningPlanIconProps) {
  const fillColor = style.color || color;
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <g clipPath="url(#clip0_3360_51695)">
        <path
          d="M10.1907 1.69531H2.03605C1.39266 1.69531 0.871094 2.17953 0.871094 2.77685V10.3476C0.871094 10.9449 1.39266 11.4291 2.03605 11.4291H10.1907C10.8341 11.4291 11.3557 10.9449 11.3557 10.3476V2.77685C11.3557 2.17953 10.8341 1.69531 10.1907 1.69531Z"
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path d="M8.41406 0.61377V2.37183" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.08789 0.61377V2.37183" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
        <line x1="1.14648" y1="4.9917" x2="11.3557" y2="4.9917" stroke={fillColor} />
      </g>
      <defs>
        <clipPath id="clip0_3360_51695">
          <rect width="12" height="12" fill="white" transform="translate(0.113281)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
